import ErrorBoundary from '@/components/ErrorBoundary';
import { StandaloneList } from '@/components/List';
import { componentClassName } from '@/styles/List';
import { LabradorComponent } from '@/types/component';
import { withNonHTMLChildren, withSafeInnerHTML } from 'lib/utils';
import mergeProps from 'lib/utils/mergeProps';
import { isArray, isArrayNotEmpty } from 'typesafe-utils';

export const AllasStandaloneList: typeof StandaloneList = ({ items, options, as, ...props }) => {
  const { $item, ...$base } = options ?? {};

  const List = as ?? 'ul';

  if (!isArray(items) || !isArrayNotEmpty(items)) {
    return null;
  }

  const listClassName = componentClassName('', {});
  const itemClassName = componentClassName('item', {});

  return (
    <ErrorBoundary>
      <List {...mergeProps({ className: listClassName }, $base)} {...props}>
        {items.map((item, i) => (
          <li key={i} {...mergeProps({ className: itemClassName }, $item)} {...withSafeInnerHTML(item)}>
            {withNonHTMLChildren(item)}
          </li>
        ))}
      </List>
    </ErrorBoundary>
  );
};

export const standalone = AllasStandaloneList;

const AllasLabradorList: LabradorComponent = ({ type, data, meta, descendants }) => {
  return <AllasStandaloneList items={data.items} as={data.tag} />;
};

export default AllasLabradorList;
